import { useCachedData } from '../hooks/useCachedData';
import { getAllUsersUsageStats } from '../services/apiService';
import CostEstimator from '../components/CostEstimator';
import { Button } from '../components/ui';

export default function UsageStats() {
  const { data, loading, error, refresh } = useCachedData<{ users: any[] }>(
    'all_users_usage',
    async () => {
      const result = await getAllUsersUsageStats();
      return result;
    }
  );

  const users = data?.users || [];

  // Aggregate totals
  const totals = users.reduce((acc, user) => {
    acc.totalInteractions += user.stats.totalInteractions;
    acc.totalInputTokens += user.stats.totalInputTokens;
    acc.totalOutputTokens += user.stats.totalOutputTokens;
    acc.totalTokens += user.stats.totalTokens;
    acc.overageInteractions += user.stats.overageInteractions;
    return acc;
  }, {
    totalInteractions: 0,
    totalInputTokens: 0,
    totalOutputTokens: 0,
    totalTokens: 0,
    overageInteractions: 0,
  });

  if (loading && !data) {
    return (
      <div className="flex h-64 items-center justify-center">
        <div className="text-center">
          <div className="mx-auto h-12 w-12 animate-spin rounded-full border-2 border-brand-primary border-t-transparent" />
          <p className="mt-4 text-sm text-neutral-secondary">Loading usage stats...</p>
        </div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="rounded-2xl border border-red-200 bg-red-50 px-5 py-4">
        <p className="text-sm text-red-800">Error loading usage stats: {error.message}</p>
        <Button variant="danger" onClick={() => refresh()} className="mt-3">
          Retry
        </Button>
      </div>
    );
  }

  const statCards = [
    { label: 'Total Interactions', value: totals.totalInteractions.toLocaleString() },
    { label: 'Total Tokens', value: totals.totalTokens.toLocaleString() },
    { label: 'Input Tokens', value: totals.totalInputTokens.toLocaleString() },
    { label: 'Output Tokens', value: totals.totalOutputTokens.toLocaleString() },
    { label: 'Overage Interactions', value: totals.overageInteractions.toLocaleString() },
  ];

  return (
    <div className="space-y-6">
      <h2 className="text-2xl font-bold text-neutral-primary">Usage Statistics</h2>

      <div className="grid grid-cols-2 gap-4 lg:grid-cols-5">
        {statCards.map((stat) => (
          <div key={stat.label} className="rounded-2xl border border-neutral-border bg-white p-5 shadow-card">
            <p className="text-sm font-medium text-neutral-secondary">{stat.label}</p>
            <p className="mt-2 text-2xl font-bold text-neutral-primary">{stat.value}</p>
          </div>
        ))}
      </div>

      {/* Cost Estimator */}
      <CostEstimator />
    </div>
  );
}
